<template>
    <div class="select"
        :class="{ 'select--autocomplete': isAutocomplete, 'selected': textInput }"
        v-click-outside="leave"> 

        <div class="select__control" >

            <input class="select__control__label"
                :class="css"
                :placeholder="placeholder" 
                v-model="textInput"
                @click="handleClick"
                @change="handleChange" 
                @focus="handleFocus" 
                @keydown="handleKeypress" 
                @keyup="handleKeyup" 
                type="text"
                v-if="active" />

            <input class="select__control__label"
                :class="css"
                :placeholder="placeholder"
                :value="selectedOption.name"
                @click="handleClick"
                type="text"
                v-else />

            <input type="hidden"
                :disabled="disabled"
                :name="name"
                :value="value"
                v-if="name" />

            <div class="select__control__actions">
                <i class="clear"
                    @click="clear"
                    v-if="isAutocomplete && value && textInput">
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10"><path d="M6.895455 5l2.842897-2.842898c.348864-.348863.348864-.914488 0-1.263636L9.106534.261648c-.348864-.348864-.914489-.348864-1.263636 0L5 3.104545 2.157102.261648c-.348863-.348864-.914488-.348864-1.263636 0L.261648.893466c-.348864.348864-.348864.914489 0 1.263636L3.104545 5 .261648 7.842898c-.348864.348863-.348864.914488 0 1.263636l.631818.631818c.348864.348864.914773.348864 1.263636 0L5 6.895455l2.842898 2.842897c.348863.348864.914772.348864 1.263636 0l.631818-.631818c.348864-.348864.348864-.914489 0-1.263636L6.895455 5z"></path></svg>
                </i>
                <i class="indicator" @click="handleClick">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" role="presentation" class="vs__open-indicator"><path d="M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z"></path></svg>
                </i>
            </div>

        </div>
        
        <ul class="select__options"
            :class="{ 'active': active }">
            <li class="select__options__item"
                :class="{ 'selected' : ( preselectedValue == item.value ) }"
                v-for="item in items"
                :key="item.value"
                @click="select(item.value)">
                {{ item.name }}
            </li>
        </ul>

    </div>
</template>

<script>
export default {

    props: {

        options: {
            type: Array,
            default: () => [],
            required: true
        },

        disabled: {
            type: Boolean,
            default: false
        },

        autocomplete: {},
        
        all: {
            type: String,
            default: ''
        },
        
        css: {
            type: String,
            default: ''
        },
        
        name: {
            type: String,
            default: ''
        },
        
        placeholder: {
            type: String,
            default: ''
        },

        value: {
            default: undefined
        }
    },

    data: function() {
        return {
            active: false,
            ctrl: false,
            input: null,
            isTyping: false,
            query: ''
        }
    },

    computed: {

        hasDefaultValue: function() {
            return (  this.all.length > 0 )
        },

        isAutocomplete: function() {
            return !( typeof this.autocomplete === 'undefined' )
        },

        items: function() {

            let items = ( this.hasDefaultValue ) ? [{ name: this.all, value: null }] : []

            if ( this.isTyping ) {

                if ( this.query.length == 0 ) {
                    return [ ...items, ...this.options]
                }

                const options = this.options.filter( option => ( option.name.toLowerCase().includes(this.query.toLowerCase() ) ) )
                return [ ...items, ...options]
            }
            
            return [ ...items, ...this.options]
        },

        preselectedValue: function() {

            if ( this.isTyping ) {
                return ( this.items.length > 0 ) ? this.items[0].value : null;
            }

            if ( this.query && this.query.length > 0 ) {
                const preselectedOption = this.items.find( item => item.name.toLowerCase().includes(this.query.toLowerCase() ) )
                if ( preselectedOption ) {
                    return preselectedOption.value
                }
            }
            
            if ( this.selectedOption != null ) {
                return this.selectedOption.value
            }
                
            return null
        },

        selectedOption: function() {   
                
            const option = this.options.find( option => this.value == option.value )
            if ( !option ) {
                return {
                    name: this.all,
                    value: null
                }
            }

            return option
        },

        textInput: {

            get: function() {

                if ( this.isTyping ) {
                    return this.query
                }

                for ( const { name, value } of this.options ) {
                    if ( this.preselectedValue && this.preselectedValue == value) {
                        return name
                    }
                }

                if ( this.hasDefaultValue ) {
                    return ''
                }

                return ''
            },

            set: function(value) {
                this.query = value ?? ''
            }
        }
    },

    methods: {

        clear(event) {
            event.stopPropagation();
            this.select(null);
        },

        handleChange() {
            // this.leave()
        },

        handleClick(event) {
            this.toggle()
            const end = this.input.value.length
            this.input.setSelectionRange(end, end)
            this.input.focus()
            event.preventDefault()
        },

        handleFocus(event) {
            if ( !this.isAutocomplete ) {
                event.target.blur()
            }
        },

        handleKeypress(event) {

            if ( this.ctrl ) return

            switch ( event.keyCode ) {

                // Ferme le dropdown si entrer ou echap sont saisis
                case 13: // entrer
                    this.select(this.preselectedValue)
                    break;

                // Ctrl
                case 17:
                    this.ctrl = true
                    break;

                // Echap
                case 27: // echap
                    this.leave()
                    break;

                // Préselectionne une valeur si les flèches sont appuyées
                case 38: //haut
                case 40: // bas
                    var direction = ( event.keyCode == 38 ) ? -1 : 1;
                    var length = this.items.length
                    var index = this.items.findIndex( item => ( item.value == this.preselectedValue ) ) + direction
                    if ( index < 0 ) {
                        index = length - 1
                    }
                    else if ( index >= length ) {
                        index = 0
                    }
                    this.preselect(this.items[index].name)
                    break;
                
                default:
                    if ( this.isAutocomplete ) {
                        this.active = true
                        this.isTyping = true
                    }
            }
        },

        handleKeyup(event) {

            switch ( event.keyCode ) {

                // Ctrl
                case 17:
                    this.ctrl = false
                    break;
            }
        },

        leave() {

            if ( !this.active ) {
                return
            }

            this.input.setSelectionRange(0, 0)
            this.input.blur()

            this.isTyping = false
            this.query = this.selectedOption.name
            this.active = false
        },
        
        open() {
            this.active = true
        },

        preselect(query) {
            this.isTyping = false
            this.query = query
        },

        select(value) {
            this.setOption(value)
            this.leave()
        },

        setOption(value) {
            this.$emit('change', value)
            this.$emit('input', value)            
        },

        toggle() {
            ( this.active ) ? this.leave() : this.open()
        }
    },

    mounted () {
        this.input = this.$el.querySelector('input')
    },
    
    watch: {

        value: function(newVal) {
            this.query = ( parseInt(newVal) && newVal != null ) ? this.items.find( item => (newVal == item.value) ).name : ''
        }
    }
}
</script>

<style>

.select {
    display: inline-block;
    position: relative;
    cursor: pointer;
    width: 100%;
}

.select input {
    cursor: pointer;
    overflow: hidden;
    padding-right: 2rem;
    text-overflow: ellipsis;
}

.select input[disabled="disabled"] {
    cursor: default;
}

.select .select__control {
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    flex: 1;
}

.select .select__control .select__control__label,
.select .select__options .select__options__item {
    padding: 0 12px;
}

.select .select__control .select__control__label {
    flex: 1;
    padding-right: 3rem;
}

.select .select__control .select__control__actions {
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    margin: 0 8px;

    display: flex;
    flex-direction: row;
    align-items: center;
}

.select .select__control .select__control__actions > * {
    fill: rgba(60,60,60,0.5);
    transform: scale(1);
}

.select .select__control .select__control__actions > *:not(:first-child) {
    margin-left: 0.5rem;
}

.select .select__options {
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    z-index: 99;
    list-style: none;
    margin: 0;
    padding: 0;
    background-color: rgb(255, 255, 255);
    box-shadow: 0px 2rem 6rem rgba(0, 0, 0, 0.46);
}

.select .select__options .select__options__item {
    line-height: 2rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.select .select__options .select__options__item:hover,
.select .select__options .select__options__item.selected {
    background-color: rgba(0, 0, 0, 0.12);
}

.select .select__options:not(.active) {
    display: none;
}

.arrow-down {
    display: inline-block;
    width: 0;
    height: 0;
    padding: 3px;
    -webkit-transform: rotate(45deg) translate(-2px);
            transform: rotate(45deg) translate(-2px);
    border: solid 5px gray;
    border-width: 0 3px 3px 0;
}

@media screen and (min-width: 800px) {

    .select {
        min-width: 6rem;
    }

    .select .select__options {
        right: initial;
        min-width: 100%;
        max-width: calc(100% + 18rem);
    }
}

</style>
